var render, staticRenderFns
import script from "./LangManager.vue?vue&type=script&lang=js&"
export * from "./LangManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2913c360",
  null
  
)

export default component.exports